import React from 'react';
import SideMenuBar from '../../components/account/SideMenuBar';
import RightBar from '../../components/account/RightBar';
import SettingContent from '../../components/account/SettingContent';
import { isMobilePage } from '../../common/cores';

const Setting = () => {
    return (
        <div data-v-623d66c4="" className="contents row" style={{flexDirection: "row"}}>
            <div data-v-623d66c4="" className="content column right-content">
                <div data-v-623d66c4="" className="column">
                    <div data-v-394b74b4="" data-v-623d66c4="" className="account row" style={{ flexDirection: "row"}}>
                        {!isMobilePage() && <SideMenuBar />}
                        <SettingContent />
                    </div>
                </div>
            </div>
            {!isMobilePage() && <RightBar />}
        </div>
    );
};

export default Setting;


// WEBPACK FOOTER //
// ./src/containers/Account/Setting.js